export default "__VITE_ASSET__CCneXKl7__"